import { useMemo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FormProvider, useForm } from 'react-hook-form';

import moment from 'moment';
import { useTranslation } from 'react-i18next';
import IconAnniversary from '../../assets/new-icons/icon-anniversary-min.png';
import IconBirthday from '../../assets/new-icons/icon-birthday-min.png';
import IconHonermoon from '../../assets/new-icons/icon-honeymoon-min.png';
import IconOthers from '../../assets/new-icons/icon-others-min.png';
import IconVacations from '../../assets/new-icons/icon-vacations-min.png';
// import IconAwesomeCheckCircle from '../../../assets/icon-awesome-check-circle.svg';
import CustomSelect from '../../ui/Form/CustomSelect';
import generateTimeList from '../../utils/generateTimeList';
import motiveList from '../../utils/motives';
import { setBooking, setDataMotive } from './bookingSlice';
import { useUpdateBookingMutation } from '../../services/majesticResortsApi';
import MessageErrorModal from '../../ui/Modals/MessageErrorModal';
import usePageNavigation from '../../hooks/usePageNavigation';
import FormErrorsModal from '../../ui/Modals/FormErrorsModal';
import CustomInput from '../../ui/Form/CustomInput';

function BookingMotivePage() {
  const { booking } = useSelector((state) => state.booking);
  const [updateBooking, { isError, error }] = useUpdateBookingMutation();
  const [showErrorsModal, setShowErrorsModal] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  const timeList = useMemo(() => generateTimeList('24h'), []);
  // console.log(timeList)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const {
    control,
    reset,
    trigger,
    register,
    setValue,
    watch,
    formState,
    handleSubmit
  } = useForm({
    defaultValues: {
      motive: {},
      prefixTime: false,
      time: false,
    },
  });

  const { errors } = formState;

  const { navigateNextPage } = usePageNavigation();

  useEffect(() => {
    for (let index = 0; index < motiveList.length; index++) {
      const element = motiveList[index];
      if (element.MotiveName.toLocaleUpperCase() === booking.MotivoViaje.toLocaleUpperCase()) {
        setValue('motive', element);
        setValue('bookingMotive', element.MotiveId);
      }
    }
  }, [setValue, booking]);

  const motive = watch('motive');

  const onSubmit = async (data) => {
    dispatch(setDataMotive(data));
    const { motive: motivo, prefixTime, time } = data;

    // let refactMotive = motivo.MotiveName.replace(/\s+/g, '').toLowerCase();
    // if (motive.MotiveType === 'ANIVERSARY') {
    //   refactMotive = motive.MotiveType.toLowerCase();
    // }

    const formattedTime = moment(time.Hora, 'hh:mm A').format('HHmm00');

    const dataUpdateBooking = {
      ...booking,
      LlegadaHora: formattedTime,
      MotivoViaje: motivo?.MotiveCodeMajestic,
    };

    const params = { d: dataUpdateBooking };
    await updateBooking(params).unwrap();

    dispatch(setBooking(dataUpdateBooking));

    navigateNextPage('ImportantRemember');
  };

  const onError = (errorList) => {
    const messages = Object.values(errorList).map((errorMap) => errorMap.message || 'Campo inválido');
    setErrorMessages(messages);
    setShowErrorsModal(true);
  };

  const handleCloseModal = () => {
    // setErrorMessage('');
    setShowErrorsModal(false);
  };

  const handleSetMotive = (motiveIndex) => {
    setValue('motive', motiveList[motiveIndex]);
    setValue('bookingMotive', motiveList[motiveIndex].MotiveId);
    trigger();
  };

  return (
    <div className="booking__motive d-flex flex-column h-100">
      <div className="text-center mb-3">
        <p className="mb-0 app-txt-granite pp-fw-figtree-regular">{t('TXT_TITLE_CHECK_IN')}</p>

        <p className="my-3 app-fs-h4 app-lh-h4 app-txt-granite app-fw-notosans-bold">{t('TXT_REASON_TRAVEL')}</p>

        <p className="mb-0 app-fs-14 app-txt-granite-80-dark px-3">{t('TXT_COMPLETE_INFORMATION')}</p>
      </div>

      <FormProvider
        control={control}
        handleSubmit={handleSubmit}
        setValue={setValue}
        watch={watch}
        formState={formState}
        register={register}
      >
        <Form onSubmit={handleSubmit(onSubmit, onError)} className="mt-3 d-flex flex-column h-100">
          <CustomInput
            control={control}
            name="bookingMotive"
            typeInput="hidden"
            rules={{ required: `${t('TXT_ERROR_MOTIVE')}` }}
            classNames={{ card: 'd-none' }}
          />
          <div className="d-flex mb-3">
            <div className="flex-fill" style={{ width: '30%' }}>
              <Card
                className={`border-solid-1 transition-border-color border-radius-5 ${motive.MotiveId === 4 ? 'motive-active app-border-sand' : 'app-border-granite-80-light'} ${errors.bookingMotive ? 'invalid-input-border' : ''}`}
                onClick={() => handleSetMotive(3)}
              >
                <Card.Body className="py-2 px-2 text-center">
                  <img src={IconVacations} alt="IconVacations" style={{ width: '35px' }} />
                  <p className="mb-0 app-fw-notosans-medium app-txt-granite-80-dark app-lh-h4 pt-1 app-fs-14">
                    {t('TXT_VACATION')}
                  </p>
                </Card.Body>
              </Card>
            </div>
            <div className="flex-fill px-2">
              <Card
                className={`border-solid-1 transition-border-color border-radius-5 ${motive.MotiveId === 3 ? 'motive-active app-border-sand' : 'app-border-granite-80-light'} ${errors.bookingMotive ? 'invalid-input-border' : ''}`}
                onClick={() => handleSetMotive(2)}
              >
                <Card.Body className="py-2 px-2 text-center">
                  <img src={IconHonermoon} alt="IconHonermoon" style={{ width: '35px' }} />
                  <p className="mb-0 app-fw-notosans-medium app-txt-granite-80-dark app-lh-h4 pt-1 app-fs-14">
                    {t('TXT_HONEYMOON')}
                  </p>
                </Card.Body>
              </Card>
            </div>
            <div className="flex-fill" style={{ width: '30%' }}>
              <Card
                className={`border-solid-1 transition-border-color border-radius-5 ${motive.MotiveId === 1 ? 'motive-active app-border-sand' : 'app-border-granite-80-light'} ${errors.bookingMotive ? 'invalid-input-border' : ''}`}
                onClick={() => handleSetMotive(0)}
              >
                <Card.Body className="py-2 px-2 text-center">
                  <img src={IconAnniversary} alt="IconAnniversary" style={{ width: '35px' }} />
                  <p className="mb-0 app-fw-notosans-medium app-txt-granite-80-dark app-lh-h4 pt-1 app-fs-14">
                    {t('TXT_ANNIVERSARY')}
                  </p>
                </Card.Body>
              </Card>
            </div>
          </div>
          <Row>
            <Col>
              <Card
                className={`border-solid-1 transition-border-color border-radius-5 ${motive.MotiveId === 2 ? 'motive-active app-border-sand' : 'app-border-granite-80-light'} ${errors.bookingMotive ? 'invalid-input-border' : ''}`}
                onClick={() => handleSetMotive(1)}
              >
                <Card.Body className="py-2 px-2 text-center">
                  <img src={IconBirthday} alt="IconBirthday" style={{ width: '35px' }} />
                  <p className="mb-0 app-fw-notosans-medium app-txt-granite-80-dark app-lh-h4 pt-1 app-fs-14">
                    {t('TXT_BIRTHDAY')}
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card
                className={`border-solid-1 transition-border-color border-radius-5 ${motive.MotiveId === 5 ? 'motive-active app-border-sand' : 'app-border-granite-80-light'} ${errors.bookingMotive ? 'invalid-input-border' : ''}`}
                onClick={() => handleSetMotive(4)}
              >
                <Card.Body className="py-2 px-2 text-center">
                  <img src={IconOthers} alt="IconOthers" style={{ width: '35px' }} />
                  <p className="mb-0 app-fw-notosans-medium app-txt-granite-80-dark app-lh-h4 pt-1 app-fs-14">
                    {t('TXT_OTHER')}
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <div className="d-flex mx-auto mt-3">
            <div className="flex-fill" style={{ width: '155px' }}>
              <CustomSelect
                control={control}
                name="time"
                formLabel={t('TXT_ARRIVAL_TIME')}
                placeHolder={t('TXT_TIME_SELECTION')}
                rules={{ required: `${t('TXT_ERROR_INPUT_REQUIRED', { inputName: t('TXT_ARRIVAL_TIME') })}` }}
                options={timeList}
                optionCode="Format"
                optionName="Hora"
                classNamePrefix="form-residence"
                classNames={{
                  card: 'border-solid-1 transition-border-color border-gray mb-2',
                  cardBody: 'px-2 py-1',
                  label: 'app-txt-granite-80-dark app-fw-notosans-bold app-fs-10',
                }}
              />
            </div>
          </div>

          <div className="d-flex flex-grow-1 align-items-end pb-2">
            <Button
              // disabled={!isValid}
              variant=""
              type="submit"
              className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height border-0"
            >
              {t('TXT_BOTON_CONTINUE')}
            </Button>
          </div>
        </Form>
      </FormProvider>
      {/* {isError && <MessageErrorModal message={error.message} />} */}
      <FormErrorsModal
        showModal={showErrorsModal}
        errorMessageList={errorMessages}
        setShowModal={setShowErrorsModal}
        handleCloseModal={handleCloseModal}
      />
    </div>
  );
}

export default BookingMotivePage;
